"use client";

import React from "react";
import styles from "./index.module.css";
import { Button } from "antd";
import { GetStartedButton } from "@/components/Home/common/GetStarted";
import { API_DOCS_URL } from "@/constant/common";

const CTA = () => {
  const titleText = "Ready to go live?";
  const subtitleText =
    "Grab your key and ship your first API call in minutes — across any product in the lineup.";
  const getStartedButtonText = "Start building";
  const docsButtonText = "Read the docs";

  return (
    <section className={styles.cta}>
      <h2>{titleText}</h2>
      <p>{subtitleText}</p>
      <div className={styles.actions}>
        <GetStartedButton className={styles.getStartedButton}>
          {getStartedButtonText}
        </GetStartedButton>
        <Button
          type="default"
          className={styles.docsButton}
          onClick={() => window.open(API_DOCS_URL)}
        >
          {docsButtonText}
        </Button>
      </div>
    </section>
  );
};

export default CTA;
